import { uploadFileRequest } from "../api/coreRequests";
import { useRequest } from "./useRequest";

export const useFileUpload = () => useRequest(uploadFileRequest);
